import { useSyncExternalStore } from "react";

/** A new service worker is waiting; `apply` activates it and reloads. */
type Apply = () => Promise<void> | void;

let pending: Apply | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function setUpdateAvailable(apply: Apply | null): void {
  pending = apply;
  emit();
}

export function useUpdateAvailable(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => pending !== null,
    () => false,
  );
}

export async function applyUpdate(): Promise<void> {
  await pending?.();
}

/** Tells the worker to forget what it cached for the previous person (after a login or logout). */
export function clearPrivateCaches(): void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.controller?.postMessage({ type: "CLEAR_PRIVATE" });
}
